import './silenceConsole'; // must be first, before modules that log on load
import { startErrorReporting } from './errorReporting';
import { startSessionRefresh } from './sessionRefresh';
import { startSupportModeInterceptors } from './supportMode';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import global_en  from './translations/en.json';
import global_da  from './translations/da.json';
import i18next from 'i18next';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';
import { I18nextProvider } from 'react-i18next';

startErrorReporting({
  app: "admin",
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  getToken: () => localStorage.getItem("access_token"),
});

startSessionRefresh();
startSupportModeInterceptors();

i18next.init({
  interpolation: {escapeValue: false},
  lng: "da",   // admin bruges internt og er kun på dansk
  resources: {
    en: {
      global: global_en
    },
    da: {
      global: global_da
    }
  }
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </I18nextProvider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Gør admin installerbar på telefonen (PWA). Service workeren gemmer kun appens egne filer.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {
      /* uden service worker virker admin som før, bare uden "installér" */
    });
  });
}
